export const Couriers = {
	NACEX: 1,
	DHL: 2,
	HAND_DELIVERY: 3,
	UPS: 4,
}
